import { usePostHogIdentification } from '@/hooks/usePostHogIdentification';

interface PostHogIdentificationProviderProps {
  children: React.ReactNode;
}

/**
 * Component that handles PostHog user identification.
 * Must be placed inside AuthProvider, TenantProvider, and PostHogProvider.
 */
export function PostHogIdentificationProvider({ children }: PostHogIdentificationProviderProps) {
  // This hook handles all the PostHog identification logic
  usePostHogIdentification();
  
  // This is a provider-like component that just runs the hook and passes through children
  return <>{children}</>;
}